document.addEventListener("DOMContentLoaded", function() {
  const header = document.querySelector("sticky-header header");

  // Posición inicial
  header.style.top = "76px";

  window.addEventListener("scroll", function() {
    const currentScroll = window.scrollY;

    if (currentScroll === 0) {
      // Cuando estamos arriba de todo
      header.style.top = "76px";
    } else {
      // Cuando hemos hecho scroll, se mantiene en 38px
      header.style.top = "43px";
    }
  });
});